import { get, filter, map, find } from "lodash";
import { BreadCrumb } from "primereact/breadcrumb";
import { Button } from "primereact/button";
import { FilterTags } from "components/FilterTags";
import { Link } from "react-router-dom";
import { PageRequestError } from "components/PageRequestError";
import { Paginator } from "primereact/paginator";
import { useTranslation } from "react-i18next";
import { Title } from "components/Title";
import useApp from "hooks/useApp";
import { useNavigate } from "react-router-dom";
import useListPage from "hooks/useListPage";
import CustomDataTable from "components/CustomDataTable";
import { Dropdown } from "primereact/dropdown";
import { useState, useEffect } from "react";
const MetricsListPage = (props) => {
  const [load, setLoad] = useState(false);
  const { t } = useTranslation();
  const METRICS = t("METRICS");
  const FILTER_BY_MODULE = t("FILTER_BY_MODULE");
  const FILTER_BY_METRIC_TYPE = t("FILTER_BY_METRIC_TYPE");
  const MODULES = t("MODULES");
  const METRIC_TYPE = t("METRIC_TYPE");
  const POSITION = t("POSITION");
  const STATUS = t("STATUS");
  const CREATE_NEW_METRIC = t("CREATE_NEW_METRIC");
  const FACILITY = t("FACILITY");
  const NAME = t("NAME");
  const OF = t("OF");

  const app = useApp();
  const { metricTypes } = app;
  const navigate = useNavigate();
  const [selectedModule, setSelectedModule] = useState(null);
  const [selectedMetricType, setSelectedMetricType] = useState(null);
  const filterSchema = {
    search: {
      tagTitle: "Search",
      value: "",
      valueType: "single",
      options: [],
    },
  };
  const pageController = useListPage(props, filterSchema, "data");
  const filterController = pageController.filterController;
  const {
    records,
    pageReady,
    loading,
    selectedItems,
    sortBy,
    sortOrder,
    apiRequestError,
    setSelectedItems,
    getPageBreadCrumbs,
    onSort,
    deleteItem,
    pagination,
  } = pageController;
  const {} = filterController;
  const {
    totalRecords,
    totalPages,
    recordsPosition,
    firstRow,
    limit,
    onPageChange,
  } = pagination;

  const constructFilterObject = () => {
    const filterObj = {};
    if (selectedModule) {
      filterObj.modules = selectedModule.id;
    }
    if (app.selectedOrg) {
      filterObj.org_code = app.selectedOrg.code;
    }
    if (selectedMetricType) {
      filterObj.metric_type = selectedMetricType.id;
    }
    return filterObj;
  };
  const metricFilterHandler = () => {
    const filterObj = constructFilterObject();
    let combinedFilterString = "";
    for (const key in filterObj) {
      if (filterObj.hasOwnProperty(key)) {
        combinedFilterString += `${key}=${filterObj[key]},`;
      }
    }
    combinedFilterString = combinedFilterString.slice(0, -1);
    app.setMetricFilterParameters(combinedFilterString);
  };

  useEffect(() => {
    metricFilterHandler();
    return () => {
      app.setMetricFilterParameters();
    };
  }, [app.selectedOrg, selectedModule, selectedMetricType]);

  function IdTemplate(data) {
    if (data) {
      return <Link to={`/metrics/view/${data.id}`}> {data.id}</Link>;
    }
  }
  const handleRowClick = (event) => {
    const rowData = event.data;
    navigate(`/metrics/view/${rowData.id}`);
  };
  function OrganisationTemplate(data) {
    let orgName = "-";
    if (data && props.organisations.length > 0) {
      const org = find(
        props.organisations,
        (org) => get(org, "code") === get(data, "org_code", null)
      );
      orgName = org ? get(org, "name", "-") : "-";
    }
    return orgName;
  }
  function ModulesTemplate(data) {
    let modulesName = "-";
    if (data && props.modules.length > 0) {
      const modules = filter(
        props.modules,
        (mod) =>
          find(
            get(data, "modules"),
            (moduleId) => moduleId === get(mod, "id", 0)
          ),
        []
      );
      modulesName =
        modules.length > 0
          ? map(modules, (module) => get(module, "module_name", "")).join(", ")
          : "-";
    }
    return modulesName;
  }
  function MetricTypeTemplate(data) {
    let metricTypeLabel = "-";
    if (data && metricTypes.length > 0) {
      const metricType = find(
        metricTypes,
        (mType) => get(mType, "id") === get(data, "metric_type", null)
      );
      metricTypeLabel = metricType ? get(metricType, "label", "-") : "-";
    }
    return metricTypeLabel;
  }
  function EmptyRecordMessage() {
    if (pageReady && !records.length) {
      return (
        <div className="text-lg mt-3 p-3 text-center text-400 font-bold">
          {t("NO_METRICS_FOUND")}
        </div>
      );
    }
  }

  function PagerControl() {
    setLoad(true);
    if (props.paginate && totalPages > 1) {
      const pagerReportTemplate = {
        layout: pagination.layout,
        CurrentPageReport: (options) => {
          return (
            <>
              <span className="text-sm text-gray-500 px-2">
                {METRICS}{" "}
                <b>
                  {recordsPosition} {OF} {options.totalRecords}
                </b>
              </span>
            </>
          );
        },
      };
      return (
        <div className="flex-grow-1">
          <Paginator
            first={firstRow}
            rows={limit}
            totalRecords={totalRecords}
            onPageChange={onPageChange}
            template={pagerReportTemplate}
          />
        </div>
      );
    }
    setLoad(false);
  }
  function PageFooter() {
    if (pageReady && props.showFooter) {
      return (
        <div className="flex flex-wrap justify-content-between">
          <PagerControl />
        </div>
      );
    }
  }
  function PageBreadcrumbs() {
    if (props.showBreadcrumbs) {
      const items = getPageBreadCrumbs();
      return items.length > 0 && <BreadCrumb className="mb-3" model={items} />;
    }
  }
  if (apiRequestError) {
    return <PageRequestError error={apiRequestError} />;
  }
  return (
    <main id="MetricsListPage" className="main-page">
      {props.showHeader && (
        <section className="page-section mb-3">
          <div className="container-fluid">
            <div className="flex justify-content-between align-items-center">
              <Title
                title={METRICS}
                titleClass="text-2xl text-primary font-bold"
                subTitleClass="text-500"
                separator={false}
              />
              <div className="grid justify-content-between align-items-center gap-2">
                <Dropdown
                  loading
                  showClear
                  filter
                  value={selectedModule}
                  onChange={(e) => setSelectedModule(e.value)}
                  options={app.modules}
                  optionLabel="module_name"
                  placeholder={FILTER_BY_MODULE}
                  emptyFilterMessage={t("NO_OPTIONS_FOUND")}
                  appendTo="self"
                  className="w-full md:w-14rem"
                />
                <Dropdown
                  loading
                  showClear
                  filter
                  value={selectedMetricType}
                  onChange={(e) => setSelectedMetricType(e.value)}
                  options={app.metricTypes}
                  optionLabel="label"
                  placeholder={FILTER_BY_METRIC_TYPE}
                  emptyFilterMessage={t("NO_OPTIONS_FOUND")}
                  appendTo="self"
                  className="w-full md:w-14rem"
                />
                <Link to={`/metrics/add`}>
                  <Button
                    label={CREATE_NEW_METRIC}
                    icon="pi pi-plus"
                    type="button"
                    className="p-button w-full bg-primary "
                  />
                </Link>
              </div>
            </div>
          </div>
        </section>
      )}
      <section className="page-section ">
        <div className="container-fluid">
          <div className="grid ">
            <div className="col comp-grid">
              <FilterTags filterController={filterController} />
              <div>
                <PageBreadcrumbs />
                <div className="page-records">
                  <CustomDataTable
                    loading={loading}
                    data={records}
                    selectionMode="checkbox"
                    selectedItems=""
                    onSelectionChange={(e) => setSelectedItems(e.value)}
                    sortField={sortBy}
                    sortOrder={sortOrder}
                    onSort={onSort}
                    rowClickHandler={handleRowClick}
                    emptyMessage={<EmptyRecordMessage />}
                    columns={[
                      { field: "id", header: "Id", body: IdTemplate },
                      {
                        field: "org_code",
                        header: FACILITY,
                        body: OrganisationTemplate,
                      },
                      {
                        field: "modules",
                        header: MODULES,
                        body: ModulesTemplate,
                      },
                      { field: "name", header: NAME },
                      {
                        field: "metric_type",
                        header: METRIC_TYPE,
                        body: MetricTypeTemplate,
                      },
                      { field: "position", header: POSITION },
                      { field: "status", header: STATUS },
                    ]}
                  />
                </div>
                <PageFooter />
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};
const withDefaultProps = (Component) => {
  const WrappedComponent = (props) => {
    const { t } = useTranslation();
    const defaultProps = {
      primaryKey: "id",
      pageName: "metrics",
      apiPath: "metrics/get_all_metrics",
      filterApiPath: "metrics/get_metrics_by_org",
      routeName: "metricslist",
      msgBeforeDelete: t("ARE_YOU_SURE_TO_DELETE_METRIC"),
      msgTitle: t("DELETE_METRIC"),
      msgAfterDelete: t("METRIC_DELETED_SUCCESSFULLY"),
      showHeader: true,
      showFooter: true,
      paginate: true,
      isSubPage: false,
      showBreadcrumbs: true,
      exportData: false,
      importData: false,
      keepRecords: false,
      multiCheckbox: true,
      search: "",
      fieldName: null,
      fieldValue: null,
      sortField: "id",
      sortDir: "asc",
      pageNo: 1,
      limit: 10,
    };
    return <Component {...defaultProps} {...props} />;
  };

  return WrappedComponent;
};
export default withDefaultProps(MetricsListPage);
